<template>
  <div id="app">
    <Navbar/>

    <div class='router-view-container'>
      <router-view/>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  components: {
    Navbar
  }
}
</script>

<style lang="stylus">
@import '../styles/modal'
@font-face {
  font-family: 'MuseoSans';
  src: url('assets/fonts/MuseoSans-100.eot');
  src: url('assets/fonts/MuseoSans-100.eot?#iefix') format('embedded-opentype'),
       url('assets/fonts/MuseoSans-100.woff2') format('woff2'),
       url('assets/fonts/MuseoSans-100.woff') format('woff'),
       url('assets/fonts/MuseoSans-100.ttf') format('truetype'),
       url('assets/fonts/MuseoSans-100.svg#wf') format('svg');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'MuseoSans';
  src: url('assets/fonts/MuseoSans-300.eot');
  src: url('assets/fonts/MuseoSans-300.eot?#iefix') format('embedded-opentype'),
       url('assets/fonts/MuseoSans-300.woff2') format('woff2'),
       url('assets/fonts/MuseoSans-300.woff') format('woff'),
       url('assets/fonts/MuseoSans-300.ttf') format('truetype'),
       url('assets/fonts/MuseoSans-300.svg#wf') format('svg');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'MuseoSans';
  src: url('assets/fonts/MuseoSans-500.eot');
  src: url('assets/fonts/MuseoSans-500.eot?#iefix') format('embedded-opentype'),
       url('assets/fonts/MuseoSans-500.woff2') format('woff2'),
       url('assets/fonts/MuseoSans-500.woff') format('woff'),
       url('assets/fonts/MuseoSans-500.ttf') format('truetype'),
       url('assets/fonts/MuseoSans-500.svg#wf') format('svg');
  font-weight: 500;
  font-style: normal;
}

#app, #app *, * {
  font-family 'MuseoSans', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale

  a, a:hover, a:active, a:focus {
    font-weight: $bold;
    text-decoration: none;
  }

  &:focus {
    outline: none;
  }
}

input {
  &::placeholder {
    color: $midGrey !important;
    font-weight: 100;
  }
}

.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.55);
}

a {
  color: $darkGrey
  &:hover {
    color: $secondaryBlue
  }
}

.router-view-container {
  display: block;
  width: 1221px;
  max-width: calc(100% - 20px);
  position: relative;
  margin: 0px auto;
  padding: 40px 0px;
}

// Global styles 👇

body {
  font-size: 14px;
  font-weight: 300;
  background-color: $lightGrey;
}

*:before, *:after {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 100;
  color: $darkGrey;
}

h3 {
  font-size: $fontHeader;
}
</style>
